import React from "react";
import app1 from '../assets/images/app1-bird-hunter.jpg';
import app2 from '../assets/images/app2-brainy-ai.jpg';
import app3 from '../assets/images/app3-meow-meow.jpg';
import app4 from '../assets/images/app4-knowit.jpg';
import app5 from '../assets/images/app-linkbox.jpg';
// import app6 from '../assets/images/app6-dustindev-tech.jpg';
import app6 from '../assets/images/app6-dustindev-tech.gif';
import app7 from '../assets/images/app7-hey-rosie.jpg';
import app8 from '../assets/images/app8-saas.jpg';

import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="project">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            
            <div className="project">
                <a href="https://www.facebook.com/profile.php?id=61575013469702" target="_blank" rel="noreferrer"><img src={app7} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.facebook.com/profile.php?id=61575013469702" target="_blank" rel="noreferrer"><h2>Hey Rosie</h2></a>
                <p>A GenAI/LLM-powered personal finance assistant that collects transactions (via n8n flows), provides a conversational chat interface (via FB Messenger) to query and update transaction information, and offers insights and financial advice based on the current situation.</p>
            </div>
            <div className="project">
                <img src={app8} className="zoom" alt="thumbnail" width="100%"/>
                <h2>My SaaS</h2>
                <p>
                    <a href="https://circles.dustindev.tech/" target="_blank" rel="noreferrer">・MyCircles (A Personal CRM helps manage your contacts effortlessly)</a><br></br>
                    <a href="https://devseed.vercel.tech/" target="_blank" rel="noreferrer">・DevSeed (The SaaS helps you manage and sharing building ideas)</a>
                </p>
            </div>
            <div className="project">
                <a href="https://github.com/haihd/BrainyAI" target="_blank" rel="noreferrer"><img src={app2} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/haihd/BrainyAI" target="_blank" rel="noreferrer"><h2>Brainy AI (fork)</h2></a>
                <p>A browser sidebar plugin that offers a cost-free alternative to products like Sider, Monica, and Merlin</p>
            </div>
            <div className="project">
                <a href="https://dustindev.tech" target="_blank" rel="noreferrer"><img src={app6} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://dustindev.tech" target="_blank" rel="noreferrer"><h2>dustindev.tech - My self-hosted corner</h2></a>
                <p>
                    <a href="https://dustindev.tech/" target="_blank" rel="noreferrer">・My home </a><br></br>
                    <a href="https://memo.dustindev.tech/" target="_blank" rel="noreferrer">・My memo vault </a><br></br>
                    <a href="https://my.dustindev.tech/" target="_blank" rel="noreferrer">・My self-hosting web apps (Git, Leantime, etc.)</a>
                </p>
            </div>
            <div className="project">
                <a href="https://knowit.vercel.app/" target="_blank" rel="noreferrer"><img src={app4} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://knowit.vercel.app/" target="_blank" rel="noreferrer"><h2>knowit</h2></a>
                <p>A Personal Knowledge Manage System</p>
            </div>
            <div className="project">
                <a href="https://uselinkbox.netlify.app/" target="_blank" rel="noreferrer"><img src={app5} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://uselinkbox.netlify.app/" target="_blank" rel="noreferrer"><h2>Linkbox</h2></a>
                <p>Create and sharing links</p>
            </div>
            <div className="project">
                <img src={app1} className="zoom" alt="thumbnail" width="100%"/>
                <h2>Bird Hunter</h2>
                <p>A hunter game with graphic inspired from the Angry Bird</p>
            </div>
            <div className="project">
                <img src={app3} className="zoom" alt="thumbnail" width="100%"/>
                <h2>Meow Meow</h2>
                <p>An iOS app for cat lovers</p>
            </div>
        </div>
    </div>
    );
}

export default Project;